module.exports = __webpack_public_path__ + "img/logo-aneel.6efa27f8.svg";